// eslint-disable-next-line no-shadow
export enum DIRECTION {
  BOTTOM,
  RIGHT
}

const END_PIXEL_CORRECTION = 5;

export default function isScrollEnd(scroller: HTMLElement, direction: DIRECTION, pixelCorrection = END_PIXEL_CORRECTION): boolean {
  if (direction === DIRECTION.BOTTOM) {
    return scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - pixelCorrection;
  }
  // direction: right
  return scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - pixelCorrection;
}
